/* agcp.js - "The chair in these photos" card (marker `agcp`), port of the R7
   prototype (pages/chair-in-photos/scripts/agcp-r7.js): an ATTACH row. The
   card has NO add to cart of its own; its check ticks the chair onto the
   page's own ADD TO CART.

   1. THE ADD: the chair rides in the theme's OWN items array. Every one of
      the theme's four add paths (layout/theme.liquid ~367, the one that runs
      on the PDP because its document-capture guard registers first and stops
      the rest; theme-combined-v2.js ~1179 and ~1304; agcf.js ~5781) ends in
      fetch('/cart/add.js', {method: 'POST', body: JSON {items: [...]}}). This
      file wraps window.fetch (the precedent: agcf.js a8CartShim, which
      extends the same array with its surcharge line): a press on the main
      ADD TO CART (or a submit of its form) ARMS it while the box is checked,
      and the next POST /cart/add.js whose items carry the desk's current
      variant (#product-variant-id) gains {id: chair variant, quantity: card
      quantity}. One request, the theme's own post-add sequence (drawer
      refreshCart() then open(), the count nodes) runs once and shows both
      lines. Unchecked, nothing is armed and the body passes untouched. If
      Shopify refuses the extended body (422), the theme's own body (the desk
      alone) is posted once more; when that goes through it was the chair
      Shopify refused (sold out since the page rendered), and the card turns
      to its sold-out state. When the desk is refused too, the theme sees
      that refusal exactly as it would have.
   2. THE PRICE: the main button's `.agcf-atc-sub` is written by the theme
      (product-hero.js ~492 mirrors #product-main-price on products without
      agcf.js; agcf.js updateAtcPrice() on customizable ones). The theme's
      text is the desk's UNIT price at any quantity (measured on the v2.99
      preview: $3,450 at quantity 2). While checked, this file writes the
      theme's OWN last text + chair unit x card quantity (read from the
      theme's last write, never recomputed, so the tick adds exactly the
      chair total whatever convention the theme's price follows; ruling
      R7c), re-applied after every theme write by a MutationObserver on that span
      (our own write is recognised by its text and its records are taken, so
      it never loops) and after the page's quantity moves (its minus/plus
      clicks, then input/change on #quantity). Unchecked, the theme's own
      last text is put back.
   3. THE CARD: its minus/plus (data-agcp-qty-step) are handled here on window
      in the capture phase and stopped, so no theme quantity handler sees
      them and the main #quantity never moves; min 1, max the input's (99).
      The card's price = unit (data-agcp-unit, cents) x quantity, written the
      way money_without_trailing_zeros writes it. A quantity press while
      unchecked checks the box (R6).
   No navigation, no reload, no dependency. */
(function () {
  "use strict";
  if (window.AGCP_BOUND) return;
  window.AGCP_BOUND = true;

  var QTY_MAX = 99;
  var ARM_MS = 15000;
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var armedAt = 0;
  var themeText = null;
  var lastWrite = null;
  var mo = null;
  var watched = null;

  function card() { return document.querySelector("[data-agcp-card]"); }
  function checkInput(c) { return c ? c.querySelector("[data-agcp-check]") : null; }
  function isOn(c) { var i = checkInput(c); return !!(i && i.checked && !i.disabled); }
  function qtyInput(c) { return c ? c.querySelector("[data-agcp-qty]") : null; }

  function bounds(input) {
    var lo = parseInt(input.getAttribute("min"), 10);
    var hi = parseInt(input.getAttribute("max"), 10);
    lo = lo > 0 ? lo : 1;
    hi = hi >= lo ? hi : QTY_MAX;
    return [lo, hi];
  }
  function clamp(input, v) { var b = bounds(input); return Math.min(b[1], Math.max(b[0], v)); }
  function qtyOf(c) {
    var input = qtyInput(c);
    if (!input) return 1;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? bounds(input)[0] : clamp(input, v);
  }

  function mainBtn() { return document.getElementById("add-to-cart-btn"); }
  function mainForm() { var b = mainBtn(); return b && b.closest ? b.closest("form") : null; }
  function mainSub() { var b = mainBtn(); return b ? b.querySelector(".agcf-atc-sub") : null; }
  function mainQtyInput() {
    var f = mainForm();
    return (f && f.querySelector("#quantity")) || document.getElementById("quantity");
  }
  function mainQty() {
    var q = mainQtyInput();
    var v = q ? parseInt(q.value, 10) : 1;
    return v > 0 ? v : 1;
  }
  function deskVariant() {
    var f = mainForm();
    var i = (f && f.querySelector("#product-variant-id")) || document.getElementById("product-variant-id");
    return i ? String(i.value || i.getAttribute("data-variant-id") || "") : "";
  }

  /* "$3,450" / "$1,351.50" <-> cents, the currency prefix/suffix kept */
  function parse(txt) {
    var m = /^(\D*?)(\d[\d,]*)(?:\.(\d{1,2}))?(\D*)$/.exec((txt || "").trim());
    if (!m) return null;
    var c = parseInt(m[2].replace(/,/g, ""), 10) * 100 + (m[3] ? parseInt((m[3] + "0").slice(0, 2), 10) : 0);
    return isNaN(c) ? null : { cents: c, tpl: [m[1], m[4]] };
  }
  function money(cents, tpl) {
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (rest) s += "." + (rest < 10 ? "0" : "") + rest;
    return tpl[0] + s + tpl[1];
  }

  function paintCard(c) {
    if (!c) return;
    c.classList.toggle("is-on", isOn(c));
    var price = c.querySelector("[data-agcp-price]");
    var unit = parseInt(c.getAttribute("data-agcp-unit"), 10);
    if (!price || isNaN(unit)) return;
    if (!price._agcpTpl) {
      var p = parse(price.textContent);
      price._agcpTpl = p ? p.tpl : ["$", ""];
    }
    var txt = money(unit * qtyOf(c), price._agcpTpl);
    if (price.textContent !== txt) price.textContent = txt;
  }

  function watch(sub) {
    if (!window.MutationObserver || sub === watched) return;
    if (mo) mo.disconnect();
    mo = new MutationObserver(applyMain);
    mo.observe(sub, { childList: true, characterData: true, subtree: true });
    watched = sub;
  }

  /* the page's own ADD TO CART price: the theme's text, or desk + chair */
  function applyMain() {
    var sub = mainSub();
    if (!sub) return;
    watch(sub);
    var cur = sub.textContent.trim();
    if (themeText === null || cur !== lastWrite) themeText = cur;
    var c = card();
    var txt = themeText;
    if (isOn(c)) {
      var base = parse(themeText);
      var unit = parseInt(c.getAttribute("data-agcp-unit"), 10);
      if (base && !isNaN(unit)) txt = money(base.cents + unit * qtyOf(c), base.tpl);
    }
    if (cur !== txt) sub.textContent = txt;
    lastWrite = txt;
    if (mo) mo.takeRecords();
  }

  function soon() {
    applyMain();
    setTimeout(applyMain, 0);
    setTimeout(applyMain, 60);
    setTimeout(applyMain, 300);
  }

  function changed(c, fromQty) {
    var chk = checkInput(c);
    if (fromQty && chk && !chk.checked && !chk.disabled) chk.checked = true;
    paintCard(c);
    applyMain();
  }

  function step(btn) {
    var c = btn.closest("[data-agcp-card]");
    var input = qtyInput(c);
    if (!input || input.disabled) return;
    var d = parseInt(btn.getAttribute("data-agcp-qty-step"), 10) || 0;
    input.value = clamp(input, qtyOf(c) + d);
    changed(c, true);
  }

  /* typing: clamp what is out of range at once; an empty field is left for
     the next keystroke (the price reads the minimum) and filled on change */
  function typed(input, done) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) {
      if (done) input.value = bounds(input)[0];
    } else {
      var n = clamp(input, v);
      if (done ? String(n) !== input.value : n !== v) input.value = n;
    }
    changed(input.closest("[data-agcp-card]"), !isNaN(v));
  }

  /* the chair became unavailable after the page rendered */
  function soldOut(c) {
    if (!c) return;
    var chk = checkInput(c);
    if (chk) { chk.checked = false; chk.disabled = true; }
    c.setAttribute("data-agcp-off", "");
    var g = c.querySelector("[data-agcp-qty-group]");
    if (g && g.parentNode) g.parentNode.removeChild(g);
    var label = c.querySelector(".agcp-at-label");
    if (label && !label.querySelector(".agcp-at-oos")) {
      var s = document.createElement("span");
      s.className = "agcp-at-oos";
      s.textContent = "Not in Stock";
      label.appendChild(document.createTextNode(" "));
      label.appendChild(s);
    }
    paintCard(c);
    applyMain();
  }

  /* ---------- the add: extend the theme's own items array ---------- */
  function arm() { armedAt = isOn(card()) ? Date.now() : 0; }

  function extend(input, init) {
    if (!armedAt || Date.now() - armedAt > ARM_MS) return null;
    if (!init || typeof init.body !== "string") return null;
    if (String(init.method || "GET").toUpperCase() !== "POST") return null;
    var url = typeof input === "string" ? input : String((input && input.url) || "");
    if (!ADD_RE.test(url)) return null;
    var c = card();
    if (!isOn(c)) return null;
    var chair = parseInt(c.getAttribute("data-variant-id"), 10);
    var desk = deskVariant();
    var data = JSON.parse(init.body);
    if (!chair || !desk || !data || !data.items || !data.items.length) return null;
    var hasDesk = false;
    for (var i = 0; i < data.items.length; i++) {
      var it = data.items[i];
      if (!it) continue;
      if (String(it.id) === String(chair)) return null;
      if (String(it.id) === desk) hasDesk = true;
    }
    if (!hasDesk) return null;
    data.items.push({ id: chair, quantity: qtyOf(c) });
    var out = {};
    for (var k in init) {
      if (Object.prototype.hasOwnProperty.call(init, k)) out[k] = init[k];
    }
    out.body = JSON.stringify(data);
    return { init: out, items: data.items, card: c };
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input, init) {
      var ext = null;
      try { ext = extend(input, init); } catch (e) { ext = null; }
      if (!ext) return nativeFetch.apply(window, arguments);
      armedAt = 0;
      return nativeFetch.call(window, input, ext.init).then(function (res) {
        if (res.ok) {
          window.AGCP_LAST_ADD = { items: ext.items, at: Date.now() };
          return res;
        }
        if (res.status !== 422) return res;
        /* the theme's own body once more; only when the desk alone goes
           through was it the chair that Shopify refused */
        return nativeFetch.call(window, input, init).then(function (alone) {
          if (alone.ok) {
            if (window.console) console.warn("agcp: the chair was refused (422); the desk was added alone");
            soldOut(ext.card);
          }
          return alone;
        });
      });
    };
  }

  /* ---------- events, all on window in the capture phase ---------- */
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest("[data-agcp-qty-step]");
    if (btn && btn.closest("[data-agcp-card]")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      step(btn);
      return;
    }
    var f = mainForm();
    if (f && f.contains(t)) {
      if (t.closest(".qty-minus, .qty-plus")) soon();
      var b = mainBtn();
      if (b && b.contains(t)) arm();
    }
  }, true);

  window.addEventListener("submit", function (e) {
    var f = mainForm();
    if (f && e.target === f) arm();
  }, true);

  function onType(done) {
    return function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches("[data-agcp-card] [data-agcp-qty]")) { typed(t, done); return; }
      if (t.matches("[data-agcp-card] [data-agcp-check]")) { changed(t.closest("[data-agcp-card]"), false); return; }
      if (t === mainQtyInput()) soon();
    };
  }
  window.addEventListener("input", onType(false), true);
  window.addEventListener("change", onType(true), true);
  window.addEventListener("pageshow", function () { paintCard(card()); applyMain(); });

  window.AGCP_STATE = function () {
    var c = card(), sub = mainSub(), price = c ? c.querySelector("[data-agcp-price]") : null;
    return { checked: isOn(c), qty: qtyOf(c), mainQty: mainQty(), card: price ? price.textContent : null,
             main: sub ? sub.textContent : null, theme: themeText, armed: !!armedAt };
  };

  paintCard(card());
  applyMain();
})();
